import CpZoneAssignment from "@/components/modules/CpZoneAssignment";

export default {
  key: "cp_zone",
  id: "zone_id",
  fields: [
    { key: "zone_id", hidden: ["write"] },
    { key: "name_chi" },
    { key: "loc_id", field: "loc_id.address", value: "loc_id.loc_id", type: "select" },
    { key: "max_physical_current_limit", disabled: ["edit"] },
    { type: "action-btn" }
  ],
  options: {
    loc_id: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    }
  },
  view: [
    ["zone_id"],
    ["name_chi"],
    [{ key: "loc_id", value: "loc_id.address" }],
    [{ type: "component", component: CpZoneAssignment }],
    [{
      type: "tabs",
      items: [
        {
          key: "cps",
          name: "cp",
          params: ["zone_id"],
          fields: [
            { key: "cp_id", width: 75 },
            { key: "cp_no" },
            { key: "name_chi" },
            // { key: "loc_id", field: "loc_id.address", value: "loc_id.loc_id", type: "select", hidden: ["list"] },
            { key: "firmware_version", width: 95 },
            // { key: "charging_status_code", field: "charging_status_code.name_chi", width: 100 },
            { key: "last_status_dttm", type: "datetime" },
            { key: "boot_dttm", type: "datetime" },
            { key: "lupd_dttm", type: "datetime" },
            { key: "enable_flag", type: "boolean", width: 70 },
            // { type: "action-btn", width: 90 }
          ]
        },
      ]
    }]
  ],
  // structure: [
  //   ["name"]
  // ],
  action: ["create","edit","view"]
}